import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
/**
 * This service is used to show the loader on the screen
 * 
 * There are two types of loader 
 * 
 * 1. Indicator loader - To show this loader you just need to call show() function
 * 
 * 2. Progress loader - To show this loader you need to pass parameter to show function (eg. show('progress'))
 */
@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  private progress = new BehaviorSubject<any>(false)
  private indicator = new BehaviorSubject<any>(false)

  public progressLoader = this.progress.asObservable();
  public indicatorLoader = this.indicator.asObservable();
  
  /**
   * This function is used to show the loader on the screen you can either pass the parameter or simply call the show() function
   * by default it will display indicator loader.
   */
  show(type?){
    if(type === 'progress'){
      this.progress.next(true)
    }else if(type === 'indicator'){
      this.indicator.next(true)
    }else{
      this.indicator.next(true)
    }
    
  }

  /**
   * This function is used to hide the loader on the screen you can either pass the parameter or simply call the hide() function
   * by default it will hide indicator loader.
   */
  hide(type?){
    if(type === 'progress'){
      this.progress.next(false)
    }else if(type === 'indicator'){
      this.indicator.next(false)
    }else{
      this.indicator.next(false)
    }
  }

}
